module.exports = __webpack_public_path__ + "img/qrcode_3.28e72c7f.png";